import styled, { css } from "styled-components";

export const Wrapper = styled.div(({ theme }) => css`
  padding: 5px 0 20px;

  .innear-arrears-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${theme.palette.main.fieldWell};
    border-radius: 15px;
  }

  .bell-icon {
    width: 22px;
    position: relative;
    left: 9px;
    top: 6.5px;
  }

  .icon-background {
    background-color: ${theme.palette.status.bad};
    height: 40px;
    width: 40px;
    border-radius: 50%;
    flex: none;
    margin-right: 15px;
  }

  .ccr-box {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    background-color: #91e585;
    border-radius: 15px;
    padding: 15px;
    margin: 20px 0;
  }
`);